if (!customElements.get('ls-product-information')) {
  customElements.define('ls-product-information', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.events = new AbortController();
      this.media = matchMedia('(min-width: 799px)');
      this.panels = [...this.querySelectorAll('details[data-panel]')];
      this.tabs = [...this.querySelectorAll('[role="tab"]')];
      this.selected = 'style';
      this.tabs.forEach((tab, i) => {
        const panel = this.panels.find(p => p.dataset.panel === tab.dataset.panel);
        tab.id = `${this.id}-tab-${i}`;
        panel.id = `${this.id}-panel-${i}`;
        tab.setAttribute('aria-controls', panel.id);
        tab.addEventListener('click', () => this.select(tab.dataset.panel), {signal:this.events.signal});
        tab.addEventListener('keydown', e => {
          let next;
          if (e.key === 'ArrowRight') next = (i + 1) % this.tabs.length;
          if (e.key === 'ArrowLeft') next = (i + this.tabs.length - 1) % this.tabs.length;
          if (e.key === 'Home') next = 0;
          if (e.key === 'End') next = this.tabs.length - 1;
          if (next === undefined) return;
          e.preventDefault(); this.select(this.tabs[next].dataset.panel); this.tabs[next].focus();
        }, {signal:this.events.signal});
      });
      this.onChange = () => this.layout();
      this.media.addEventListener('change', this.onChange);
      this.onShortcut = e => {
        const link = e.target.closest('[data-ls-shipping-link]');
        if (!link || link.getAttribute('href') !== `#${this.id}`) return;
        e.preventDefault(); this.select('shipping');
        const panel = this.panels.find(p => p.dataset.panel === 'shipping');
        const target = this.media.matches ? this.tabs.find(t => t.dataset.panel === 'shipping') : panel.querySelector('summary');
        target.focus({preventScroll:true});
        target.scrollIntoView({block:'center', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      };
      document.addEventListener('click', this.onShortcut);
      this.dataset.enhanced = ''; this.layout();
    }
    disconnectedCallback() {
      this.events?.abort();
      this.media?.removeEventListener('change', this.onChange);
      document.removeEventListener('click', this.onShortcut);
      this.initialized = false;
    }
    select(name) {
      this.selected = name;
      if (this.media.matches) this.layout();
      else this.panels.find(p => p.dataset.panel === name).open = true;
    }
    layout() {
      const desktop = this.media.matches;
      this.querySelector('[role="tablist"]').hidden = !desktop;
      this.panels.forEach((panel, i) => {
        panel.hidden = desktop && panel.dataset.panel !== this.selected;
        panel.open = desktop ? !panel.hidden : panel.dataset.panel === 'style';
        if (desktop) { panel.setAttribute('role','tabpanel'); panel.setAttribute('aria-labelledby',this.tabs[i].id); }
        else { panel.removeAttribute('role'); panel.removeAttribute('aria-labelledby'); }
      });
      this.tabs.forEach(tab => {
        const selected = tab.dataset.panel === this.selected;
        tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1;
      });
    }
  });
}
